import { render } from "./HomeTiraPedido.vue?vue&type=template&id=cf9ce59e"
import script from "./HomeTiraPedido.vue?vue&type=script&lang=js"
export * from "./HomeTiraPedido.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__